/* @flow */
// typecheck: ignore file
import Link from 'components/Link.jsx';
import React from 'react';

import cx from 'classnames';
import './styles/MenuItem.scss';

class MenuItem extends React.Component {
  static propTypes = {
    href: React.PropTypes.string,
    to: React.PropTypes.string,
    onSelect: React.PropTypes.func,
    onClick: React.PropTypes.func,
    // XXX this is whack typing
    // `selected` can take `true`, `false`, and `null`. When `true` or `false', the
    // item is considered "selectable" and will render a checkmark when checked.
    selected: React.PropTypes.bool,
    disabled: React.PropTypes.bool,
    // Used by Menu
    menuKey: React.PropTypes.any,
    eventScreenName: React.PropTypes.string,
    eventElementName: React.PropTypes.string,
    eventProperties: React.PropTypes.object,
  };

  static defaultProps = {
    disabled: false,
    value: null,
    selected: null,
  };

  // typecheck: ignore statement
  handleClick = (event: SyntheticMouseEvent) => {
    if (this.props.disabled) {
      event.preventDefault();
    }

    if (this.props.disabled) {
      return;
    }

    if (this.props.selected) {
      return;
    }

    if (this.props.onSelect) {
      this.props.onSelect(this.props.menuKey);
    }

    if (this.props.onClick) {
      this.props.onClick(event);
    }
  };

  render() {
    const { className, ...others } = this.props;
    return (
      <li
        className={cx('MenuItem', {
          'MenuItem--selectable': typeof this.props.selected === 'boolean',
          'MenuItem--selected': !!this.props.selected,
          'MenuItem--disabled': this.props.disabled,
        }, className)}>
        <Link
          {...others}
          color={!this.props.selected && 'thunder'}
          className="MenuItem-link"
          eventScreenName={this.props.eventScreenName}
          eventElementName={this.props.eventElementName}
          eventProperties={this.props.eventProperties}
          onClick={this.handleClick}>
          {this.props.children}
        </Link>
      </li>
    );
  }
}

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/MenuItem.jsx